@if (type === 'text') {
    <div class="mt-1" id="facility-information-message">
        <span class="footer-message mat-subtitle-1">{{ message }}</span>
    </div>
}
@if (type === 'email') {
    <div class="mt-1">
        <div class="d-flex flex-row align-items-center" id="facility-information-email">
            {{ message }} &nbsp;
            <a [href]="'mailto:' + email | sanitize: 'url'" class="footer-email mat-subtitle-1 mb-0">
                {{ email }}
            </a>
        </div>
    </div>
}
@if (type === 'link') {
    <div class="mt-1" id="facility-information-link">
        <a [href]="url | sanitize: 'url'" class="footer-link mat-subtitle-1"> {{ message }} </a>
    </div>
}
